import { put, call, select, take, race } from 'redux-saga/effects';
import { takeEvery, takeLatest, delay } from 'redux-saga';

import * as Api from 'api';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';

/***************************** Selectors ************************************/
const getOptions = ({ canvassing : { size, offset, total, filtered_marker_types: types, filter_user: user } }) => ({ size, offset, total, types, user });
/***************************** Subroutines ************************************/
function * fetchMarkers({ payload: bounds }) {
  const options = {
    ...(yield select(getOptions)),
    bounds
  };

  try {
    const results = yield Api.fetchMarkers(options);
    yield put({type: ActionTypes.FETCH_MARKERS_SUCCESS, payload : {...results}});
  }
  catch(ex) {
    yield put(Actions.notify(ex));
    yield put({type: ActionTypes.FETCH_MARKERS_FAILED, payload : {...ex}})
  }
}

function *createMarker({payload : {marker}}) {
  try {
    if(!marker || !marker.location) {
      throw Error('You must provide a valid location and place to create a marker.')
    }
    yield put(Actions.sendSocketEmit({marker},'create-marker'));
  }
  catch(ex) {
    yield put(Actions.notify({title:"Error Creating Marker", message: ex.message}, {type:'danger'}));
    yield put({type: ActionTypes.CREATE_MARKER_FAILED, payload: {...ex}});
  }
}

function *updateMarker({payload : {marker}}) {
  try {
    if(!marker || !marker.location) {
      throw Error('You must provide a valid location and place to create a marker.')
    }
    yield put(Actions.sendSocketEmit({marker},'update-marker'));
  }
  catch(ex) {
    yield put(Actions.notify({message: ex.message}, {type: 'danger'}));
    yield put({type: ActionTypes.UPDATE_MARKER_FAILED, payload: {...ex}});
  }
}

function *deleteMarker({payload : {marker}}) {
  try {
    yield put(Actions.sendSocketEmit({marker},'delete-marker'));
  }
  catch(ex) {
    yield put(Actions.notify(ex));
    yield put({type: ActionTypes.DELETE_MARKER_FAILED, payload: {...ex}});
  }
}

function *handleError({ payload : { message }}) {
  yield put(Actions.notify({ message }, { type: 'error' }));
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/
export function * markersWatcher() {
  yield * [
    takeLatest(ActionTypes.UPDATE_MARKER_FAILED, handleError),
    takeLatest(ActionTypes.CREATE_MARKER_FAILED, handleError),
    takeLatest(ActionTypes.DELETE_MARKER_FAILED, handleError),
    takeLatest(ActionTypes.FETCH_MARKERS_FAILED, handleError),
    takeLatest(ActionTypes.FETCH_MARKERS, fetchMarkers),
    takeLatest(ActionTypes.CREATE_MARKER, createMarker),
    takeLatest(ActionTypes.UPDATE_MARKER, updateMarker),
    takeLatest(ActionTypes.DELETE_MARKER, deleteMarker),
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/markers.js